// Curated client reviews shown on the About Me page.
// Sourced from Alexander Conti's public reviews on Facebook and Rate My Agent.
// No dates, no photos — just the client, their words, and star rating.
//
// To add a new review: append to REVIEWS below. Keep verbatim if possible.
// Truncate long reviews at a natural sentence boundary with a trailing "…".

export const REVIEWS = [
  {
    id: 'r-brad-bridges',
    author: 'Brad Bridges',
    rating: 5,
    location: 'Home Purchase in Brantford',
    source: 'Rate My Agent',
    text: `I could not possibly recommend Alexander enough. I had been hoping against all odds to have a new home by Christmas. I met Alexander during the first day or two of December, and somehow I was able to acquire my new home by December 22nd. Alexander is professional, knowledgeable, efficient, and damn good at his job. Highly recommended!`,
  },
  {
    id: 'r-isoken-aigbe',
    author: 'Isoken Aigbe',
    rating: 5,
    location: 'Home Purchase in Brantford',
    source: 'Rate My Agent',
    text: `Working with Alexander Conti was exceptionally productive. He held my hand throughout the entire process and came through in other ways that were outside his services. His recommendations were also particularly helpful and useful and I believe it is due to his great rapport with individuals and businesses. It was a pleasant experience.`,
  },
  {
    id: 'r-matt-pereira',
    author: 'Matt Pereira',
    rating: 5,
    source: 'Facebook',
    text: `Alex was an integral part in getting me into my first home and I can't say enough positive things about him and his approach! He treated me like family right from the start, and was always there to answer questions or setup numerous showings for places I was interested in. He was incredibly honest and it was clear that he puts his client's best interest before his own! Thanks again Alex!`,
  },
  {
    id: 'r-frederik-larssen',
    author: 'Frederik Larssen',
    rating: 5,
    source: 'Facebook',
    text: `Had the pleasure of working with Alex. As a first time home buyer he helped guide me and understand the ins and outs. Great guy and always quick to respond if you need help or have questions! Very happy with the service!`,
  },
  {
    id: 'r-chiezmi-lawsof',
    author: 'Chiezmi LawSof',
    rating: 5,
    source: 'Facebook',
    text: `I can't thank you enough Alex for finding our forever home. You worked diligently hard to getting us what we need. You were honest and so knowledgeable. You answered all the questions and patiently repeated what we needed to understand over and over again. Again we appreciate everything you have done for us. God Bless.`,
  },
  {
    id: 'r-justin-dinola',
    author: 'Justin Dinola',
    rating: 5,
    source: 'Facebook',
    text: `Thanks a lot to Alex Conti for the great experience he gave us in buying our first home. Very professional and always available to answer our questions. Alex really knows the markets and showed my wife and I where we could get the most for our buck. We found our dream home. Thanks a lot Alex!`,
  },
  {
    id: 'r-kelz-isoh',
    author: 'Kelz Isoh',
    rating: 5,
    source: 'Facebook',
    text: `My realtor was Alexander Conti. When we eventually worked together to find a home, I'm sure he did not expect the kind of personal and family drama that later sufficed. Despite the conundrum, Alex remained professional, detailed, positive, supportive, encouraging, enthusiastic and extremely helpful in navigating the whole process. He made a promise that if it took weeks or years to find the perfect house, he's consistent and available…`,
  },
  {
    id: 'r-jeff-hannah',
    author: 'Jeff Hannah',
    rating: 5,
    location: 'Home Purchase in Paris, ON',
    source: 'Facebook',
    text: `I recently bought a house in Paris, Ontario and I wanted to share my positive experience I had with Alexander Conti. Alex is an amazing real estate agent! His philosophy of 'treat your client like family' was evident throughout my purchase process, house visits, home inspection, and his comparative market analysis. Alex truly understands the housing market and what to look for when purchasing a home.`,
  },
];

// Aggregate stats for the carousel header
export const REVIEW_STATS = {
  averageRating: 5.0,
  totalReviews: REVIEWS.length,
};
